<template>
  <div id="info" class="d-flex flex-row">
    <navbar />
    <transition name="fade" mode="out-in">
      <router-view class="overflow-scroll" style="max-width: 95vw" />
    </transition>
  </div>
</template>

<script>
import navbar from '@/components/navbar/Navbar.vue';

export default {
  name: 'info',

  components: { navbar },
};
</script>

<style lang="scss">
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 300ms ease;
  // transition-delay: 300ms;
}

.fade-leave-active {
  transition: opacity 300ms ease;
  opacity: 0;
}
</style>
